// extracted by mini-css-extract-plugin
export var audioPlayer = "_o3-0";